import { Inject, Injectable } from "@angular/core";
import { AppMetaData, AppMetaDataItemNames, ProcessorConfigEntity, ProcessorConfigQueryBuilder,
         PaymentMethodEntity } from "../../../meta-data/app-meta-data.service";
import { DevwareMetaData, DwCacheService, DwConfigService, DwConfigServiceToken, DwEventService, DwMetaDataService, DwMetaDataServiceToken, DwOrmData, DwOrmDataService, DwOrmDataServiceToken, DwSecurityTopics, DwSecurityUserService, SuppressErrorMessagesHeader, areEqual, deepCopy } from "@devwareapps/devware-cap";
import { Observable, combineLatest, of } from "rxjs";
import { Router } from "@angular/router";
import { map, mergeMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { CoursePriceRequest } from "../models/course-price-request.model";
import { CoursePriceResult } from "../models/course-price-result.model";
import { SubscriptionPriceRequest } from "../models/subscription-price-request.model";
import { SubscriptionPriceResult } from "../models/subscription-price-result.model";

@Injectable({ providedIn: 'root' })
export class PaymentsPricingRepositoryService {
    pricingApi: string;
   
    constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        @Inject(DwConfigServiceToken) private configService: DwConfigService,
        private dwSecurityUserService: DwSecurityUserService,
        private dwCacheService: DwCacheService,

        private http: HttpClient
    ) {

        this.pricingApi = `${this.configService.coreConfig.apiRoot}/aviator-online/payments/pricing`;
    }

    getCoursePricing(coursePriceRequest: CoursePriceRequest): Observable<CoursePriceResult> {
        const url = `${this.pricingApi}/getcoursepricing`;

        return this.http.post<CoursePriceResult>(url, coursePriceRequest);
    }


    getSubscriptionPricing(subscriptionPriceRequest: SubscriptionPriceRequest) : Observable<SubscriptionPriceResult>{
        const url = `${this.pricingApi}/getsubscriptionpricing`;

        return this.http.post<SubscriptionPriceResult>(url, subscriptionPriceRequest);
    }


}